import { useState } from "react";
import { reviews } from "@/mocks/galleryPizza";

export default function ReviewsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const prev = () => setActiveIndex((i) => (i === 0 ? reviews.length - 1 : i - 1));
  const next = () => setActiveIndex((i) => (i === reviews.length - 1 ? 0 : i + 1));

  const review = reviews[activeIndex];

  return (
    <section className="bg-[#1A1A1A] py-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Left: Interior Photo */}
          <div className="w-full lg:w-[45%] shrink-0">
            <div className="relative rounded-3xl overflow-hidden h-[380px] md:h-[480px]">
              <img
                src="https://storage.readdy-site.link/project_files/79ff7ea2-8c86-4f89-8525-06b9592dfb7b/0ff77299-1a50-4841-aa04-bcf564691280_600266422_1503136865148307_8620202786303666063_n.jpg?v=161822803e9feb70bd5ef2eec978979f"
                alt="Gallery Pizza interior"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/40 to-transparent" />
              {/* Rating Badge */}
              <div className="absolute top-5 right-5 bg-[#FAF8F5] rounded-2xl px-4 py-3 flex items-center gap-2">
                <i className="ri-star-fill text-[#FF6B35] text-base" />
                <span className="text-[#1A1A1A] font-bold text-sm">4.8 Google</span>
              </div>
            </div>
          </div>

          {/* Right: Review Content */}
          <div className="w-full lg:w-[55%]">
            <p className="text-[#FF6B35] text-xs font-semibold tracking-[0.25em] uppercase mb-3">(Reviews)</p>
            <h2 className="text-[#FAF8F5] font-extrabold text-4xl md:text-5xl mb-2 leading-tight">
              Loved by Travelers and Locals
            </h2>
            <p className="text-[#8B6F47] text-3xl md:text-4xl font-extrabold mb-10">Since Opening</p>

            {/* Quote */}
            <div className="relative mb-8">
              <span className="absolute -top-4 -left-2 text-[#FF6B35]/20 text-8xl font-serif leading-none select-none">&ldquo;</span>
              <p className="text-[#FAF8F5]/80 text-lg leading-relaxed pl-6 relative z-10">
                {review.text}
              </p>
            </div>

            {/* Attribution */}
            <div className="flex items-center gap-3 mb-10">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35] rounded-full shrink-0">
                <i className="ri-user-line text-[#1A1A1A] text-base" />
              </div>
              <div>
                <p className="text-[#FAF8F5] font-bold text-sm">{review.name}</p>
                <p className="text-[#8B6F47] text-xs">{review.source} &bull; {review.origin}</p>
              </div>
              <div className="ml-auto flex gap-0.5">
                {[1,2,3,4,5].map((s) => (
                  <i key={s} className="ri-star-fill text-[#FF6B35] text-sm" />
                ))}
              </div>
            </div>

            {/* Controls */}
            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                className="w-11 h-11 flex items-center justify-center rounded-full border border-[#FAF8F5]/20 text-[#FAF8F5] hover:border-[#FF6B35] hover:text-[#FF6B35] transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-arrow-left-line text-lg" />
              </button>
              <button
                onClick={next}
                className="w-11 h-11 flex items-center justify-center rounded-full bg-[#FF6B35] text-[#1A1A1A] hover:bg-[#e55a24] transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-arrow-right-line text-lg" />
              </button>
              <div className="flex gap-2 ml-4">
                {reviews.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveIndex(i)}
                    className={`rounded-full transition-all duration-200 cursor-pointer ${
                      i === activeIndex ? "w-6 h-2 bg-[#FF6B35]" : "w-2 h-2 bg-[#FAF8F5]/20"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
